"use strict";

import jQuery from 'jquery';

/**
 * Button-Group-Registry. Hier werden die <code>name</code>'s von Radio-Buttons
 * gespeichert, um sie einander zuordnen zu können.
 *
 * @type {{}}
 */
gc.gis.widget.buttongroups = {
};

/**
 * @classdesc
 * Radiobutton-Widget.
 *
 * @class
 * @extends gc.gis.widget.GCItem
 * @memberof gc.gis.widget
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object<string,*>} options Aufrufoptionen
 * @param {boolean} options.active Initial checked?
 */
gc.gis.widget.GCRadioItem = function( options )
{
	this.group  = options.group;
	this.active = options.active;

	if( this.group && !gc.gis.widget.buttongroups[this.group] )
	{
		gc.gis.widget.buttongroups[this.group] = [];
		gc.gis.widget.buttongroups[this.group].push( this );
	}
	else if( this.group )	// FIXME: additional contains()-check!
	{
		gc.gis.widget.buttongroups[this.group].push( this );
	}

	gc.gis.widget.GCItem.call( this, options );
};
gc.gis.widget.GCRadioItem.prototype = Object.create( gc.gis.widget.GCItem.prototype );

/**
 * @inheritdoc
 */
gc.gis.widget.GCRadioItem.prototype.setActive = function( active )
{
	gc.gis.widget.GCItem.prototype.setActive.call( this, active );

	if( active )
	{
		this.element_control.prop('checked', true);	// do not use self.element_control.attr('checked', 'checked');
		this.element_label.addClass('active').addClass('gc-active');
	}
	else
	{
		this.element_control.removeAttr('checked');
		this.element_label.removeClass('active').removeClass('gc-active');
	}
};

/**
 * @inheritdoc
 */
gc.gis.widget.GCRadioItem.prototype._render = function()
{
	var self = this;

	// input
	self.element_control = jQuery('<input>', {
		type: 'radio',
		name: self.group,
		'class': 'gc-widget-control',
		click: function( evt ) {
			evt.preventDefault();
			try
			{
				// execute events
				if( self.action ) {
					self.action.execute( self );
				}
				if( self.click ) {
					self.click.call( self, evt );
				}

				// set/unset 'active' class
				var members = gc.gis.widget.buttongroups[self.group];
				for( var i=0; i<members.length; i++ )
				{
					if( members[i] !== self ) {
						members[i].getElement().removeClass('active');
						members[i].getElement().children().removeClass('active');
					}
				}

				if( jQuery(self.element_control).is(':checked') ) {
					if (self.element)
					{
						self.element.addClass('active');
						self.element.children().addClass('active');
					}
				}
			}
			catch( err )
			{
				gc.gis.iface.log.error( self, err );

			}
			jQuery(this).blur();
		}
	});

	// label
	if( this.label || this.icon || this.tooltip )
	{
		// Labeltext
		var element_label_text = jQuery('<span>', {
			'class': 'gc-widget-label-text',
			text: (self.label ? self.label : '')
		});

		// Tooltip
		/*
		var element_tooltip_text = jQuery('<span>', {
			'class': 'gc-widget-tooltip-text',
			text: (self.tooltip ? self.tooltip : '')
		});
		//*/

		// Labelelement
		self.element_label = jQuery('<label>', {
			title: self.tooltip ? self.tooltip : self.label,
			'class': 'gc-button gc-button-radio gc-widget-label'
				+ (self.tooltip ? ' gc-widget-tooltip' : '')
				+ (self.badge ? ' gc-widget-badge' : '')
				+ (self.className ? ' '+ self.className : '')
		});
		self.element_label.prepend( self.element_control );

		if( self.icon ) {
			self.element_label.append( jQuery('<span>', {
				'class': 'gc-icon '+ self.icon
			}) );
		}
		if( self.label ) {
			self.element_label.append( element_label_text );
		}
		if(self.tooltip)
		{
			gc.gis.iface.ui.tooltip(self.element_label);
		}
		if( self.badge ) {
			self.element_label.append( self.badge.getElement() );
		}
	}
	else {
		self.element_label = self.element_control;
	}

	// Container
	var item = jQuery('<div>', {
		'class': 'gc-widget gc-widget-item'
			+ (self.containerClassName ? ' '+ self.containerClassName : '')
	});
	item.append( self.element_label );

	// Initiale Aktion?
	if( self.active === true )
	{
		self.element_control.click();
		item.addClass('active');
		self.element_label.addClass('active');
	}

	return item;
};

